<template lang="pug">
  tbody
    tr.table-collapse-target
      td Box - {{ box.id }}
      td {{ box.shelf }}
      td {{ quantity }}
      td {{ box.weight }}
      td {{ box.height }}
      td {{ box.width }}
      td {{ box.length }}
      td.d-flex.justify-content-end
        button.btn.btn-primary(v-if="['worker', 'admin'].indexOf(user_role) !== -1",
          title="delete", @click="setDeleteBox(box.id)")
          span.oi.oi-trash
    tr
      td.table-collapse-inner(colspan="8")
        div.table-collapse-body
          table
            thead
              tr.products-preview
                th.td-05 Image
                th.td-15 Title
                th.td-1 Asin
                th.td-1 Fnsku
                th.td-05 Condition
                th.td-05 Quantity
                th.td-05(v-if="app_section === 'storage'") Size
                th.td-1 Received date
                th.td-15 Client comment
                th.td-15 Worker comment
            tbody
              tr(v-for="product in box.products")
                td
                  img(:src="product.image")
                td {{ product.title }}
                td
                  a(:href='product.getAmazonUrl()', target='_blank') {{ product.asin }}
                td {{ product.fnsku }}
                td {{ product.condition === 0 ? 'Good' : product.condition === 1 ? 'Bad' : 'Attention' }}
                td {{ product.quantity }}
                td(v-if="app_section === 'storage'" v-html="product.getProductsSize()")
                td {{ product.received_date }}
                td {{ product.comment_client }}
                td {{ product.worker_comment }}
</template>

<script>
  import DeleteModal from '@/components/modals/delete';

  export default {
    props: {
      box: Object,
      index: Number,
      setDeleteBox: Function,
    },
    data() {
      return {
        showDeleteModal: false,
      };
    },
    components: { DeleteModal },
    computed: {
      user_role() {
        return this.$store.state.users.role;
      },
      quantity() {
        return this.box.products.reduce((sum, product) => sum + product.quantity, 0);
      },
      app_section() {
        return this.$store.getters.get_app_section;
      },
    },
  };
</script>
